import {Component, Injector} from '@angular/core';
import {ActivatedRoute, Route, Router} from '@angular/router';
import {AppComponent} from '../app.component';

@Component({
    template: ''
})
export abstract class BaseComponent {

    public abstract debug: boolean;
    private readonly fullUrlPath: string = '';

    urls: string[] = [];
    isBrowser: boolean = false;

    protected constructor(public route: ActivatedRoute,
                          public router: Router,
                          public injector: Injector) {
        AppComponent.isBrowser.subscribe((isBrowser: boolean) => this.isBrowser = isBrowser);

        this.router.config.forEach((i: Route): void => {
            this.getPaths(i);
        });

        /** Known custom routes can be added here */
        this.urls.push('/main/retail');

        this.fullUrlPath = this.router.url;
    }

    getPaths(route: Route, parent: string = ''): void {
        if (route.redirectTo) {
            return;
        }
        if (route.children) {
            route.children.forEach((i: Route): void => {
                this.getPaths(i, parent + (parent.endsWith('/') ? '' : '/') + route.path);
            });
        } else if (route.loadChildren) {
            (<any>this.router).navigationTransitions.configLoader.loadChildren(this.injector, route).subscribe(i => {
                i.routes.forEach(j => {
                    this.getPaths(j, parent + (parent.endsWith('/') ? '' : '/') + route.path);
                });
            });
        } else if (route.path != null) {
            this.setPath(route.path, parent);
        }
    }

    setPath(path, parent): void {
        let fullPath: string;
        if (path != null) {
            if (parent) {
                fullPath = (parent.startsWith('/') ? `${parent}` : `/${parent}`) + (parent.endsWith('/') ? `${path}` : `/${path}`);
            } else {
                fullPath = path.startsWith('/') ? `${path}` : `/${path}`;
            }
        }
        this.urls.push(fullPath);
    }

    public log(output: string): void {
        if (this.isBrowser && this.debug) {
            console.log(output);
        }
    }
    
    public getFullUrlPath(): string {
        return this.fullUrlPath;
    }

    public getUrls(): string[] {
        return this.urls;
    }
}
